import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";

export const AirLine = () => {

    const airline = useDataBean(_AirLine);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        airline.instance.getAirLineCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountNit ?? "") + "-" + (user.DataBeanProperties.AccountName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        airline.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        airline.instance.deleteAirLine(airline.bean.IDAirLine).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        airline.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDAirLine', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Código IATA', property: 'IATACode', visible: true },
        { title: 'Ciudad', property: 'SiteIDName', visible: true },
        { title: 'Tercero', property: 'Cient', visible: true },
        { title: 'Habilitada', property: 'Enabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <BasicPage titulo="Aerolíneas">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={airline.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={airline.bean.Name} onChange={airline.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <CitiesEditor render={airline.bean.SiteIDName} idSelector={airline.bean.IDCities} onChange={(e) => { airline.setBean({ ...airline.bean, "IDCities": e.IDCities, "SiteIDName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Tercero" idAccount={airline.bean.IDAccount} onChange={(e) => { airline.setBean({ ...airline.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            {/* <div className="col-md-6">
                                <SelectSiteID edit idLnSite={airline.bean.IDLnSiteID} label="Ubicación Geográfica" onChange={(e) => { airline.setBean({ ...airline.bean, "IDLnSiteID": e.IDLn }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Código IATA</label>
                                <input type="text" name="IATACode" className="form-control" value={airline.bean.IATACode} onChange={(e) => { airline.setBean({ ...airline.bean, "IATACode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitada" estado={airline.bean.Enabled} eventChange={(e: any) => { airline.setBean({ ...airline.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={airline.bean.Description} onChange={airline.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {airline.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}